import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.00268 11.7909C1.00138 11.8603 1.00073 11.93 1.00073 11.9998C1.00073 14.7844 2.03545 17.3274 3.74138 19.2652L6.55581 13.6775L1.00268 11.7909Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.22979 9.75577L9.37644 12.5234L5.2611 20.6939C7.12288 22.1393 9.46131 22.9998 12.0007 22.9998C18.0759 22.9998 23.0007 18.0749 23.0007 11.9998C23.0007 11.834 22.9971 11.6691 22.9898 11.5052L20.6429 12.8645L16.2579 17.9474L14.27 13.9148L10.976 12.8012V8.73405L9.24126 8.14755L7.21923 10.1984L1.70484 8.119C1.50593 8.64648 1.34638 9.19326 1.22979 9.75577Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.58303 6.31269L6.70807 7.86821L8.69594 5.85197L12.976 7.29902V11.3661L15.6969 12.286L16.7164 14.3542L19.3488 11.3028L22.6846 9.37069C21.506 4.56507 17.1697 0.999756 12.0007 0.999756C8.00689 0.999756 4.51017 3.12822 2.58303 6.31269Z"}}]};

const EarthFilled = Vue.extend<IconProps>({
  name: 'EarthFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'earth-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default EarthFilled;
